export enum MdEnableStatusEnum {
	DISABLE,
	ENABLE,
}

export enum PartnerTypeEnum {
	CUSTOMER = 'PARTNER-TYPE.CUS',
	SUPPLIER = 'PARTNER-TYPE.SUP',
}

export enum UserTypeEnum {
	EMPLOYEE = 'user-type.employee', // "内部员工"
	MICRO_BOSS = 'user-type.micro-boss', // "微老板"
	DRIVER = 'user-type.driver', //"司机"
	HEADMAN = 'user-type.headman', //"队长"
	BOSS = 'user-type.boss', // "老板"
	SUPPLIER = 'user-type.supplier', //"供应商"
	CUSTOMER = 'user-type.customer', //"客户"
}

export enum TradeTypeEnum {
	SALE = 'trade-type.sale', //销售,
	PURCHASE = 'trade-type.purchase', //采购
	SALE_RETURN = 'trade-type.sale-return', //销售退货
	PURCHASE_RETURN = 'trade-type.purchase-return', //采采购退货
	PURCHASE_PLAN = 'trade-type.purchase-plan', //采购计划
	SALE_ORDER = 'trade-type.sale-order', //销售订单
	APPOINTMENT = 'trade-type.appointment', //预约
	MAINTENANCE = 'trade-type.maintenance', //维修
	DISPATCH = 'trade-type.dispatch', //派工
	SETTLE = 'trade-type.settle', //结算
	RETURN_VISIT = 'trade-type.return-visit', //回访
	STOCKTAKING = 'trade-type.stocktaking', //盘库
	LOSS = 'trade-type.loss', //损失
	BILL_DISCOUNT = 'trade-type.bill-discount', //账单抹零
}

export enum ReviewStatusEnum {
	INIT,
	REVIEWING,
	REVIEWED,
	REJECTED = 9,
}

export enum AccountStatusEnum {
	INIT,
	DISABLED = 9,
}

export enum CreditFlagEnum {
	NON_CREDIT,
	CREDIT,
}

export enum AdjustStatusEnum {
	INIT,
	REVIEWING,
	ADJUSTED,
	REJECTED = 8,
	FAIL,
}

export enum RechargeStatusEnum {
	INIT,
	RECHARGED,
	FAIL = 9,
}

export enum TransferStatusEnum {
	INIT,
	RECHARGED,
	FAIL = 9,
}

export enum AccountLogTypeEnum {
	OPEN = 'OPEN',
	DISABLE = 'DISABLE',
	ENABLE = 'ENABLE',
	ADJUST = 'ADJUST',
	ADJUST_APPROVAL = 'ADJUST_APPROVAL',
	RECHARGE = 'RECHARGE',
	TRANSFER_IN = 'TRANSFER_IN',
	TRANSFER_OUT = 'TRANSFER_OUT',
	BALANCE = 'BALANCE',
	UPDATE = 'UPDATE',
}

export enum BillIoFlagEnum {
	IN = 1,
	OUT,
}

export enum BillPayTypeEnum {
	CASH = 1,
	CREDIT_ACCOUNT,
}

export enum BillStatusEnum {
	INIT,
	BOOKED,
	BALANCED,
}

export enum BillCashStatusEnum {
	INIT,
	CASHED,
	RECHARGED,
	BALANCED,
	FAIL = 9,
}

export enum BillCancelStatusEnum {
	INIT,
	REVIEWING,
	CANCELLED,
	FAIL,
}

export enum BillInvoiceStatusEnum {
	INIT,
	APPLYING,
	PARTIAL,
	INVOICED,
}

export enum BillBalanceStatusEnum {
	INIT,
	BALANCED,
	FAIL = 9,
}

export enum BillLogTypeEnum {
	INSERT = 'INSERT',
	APPROVAL = 'DISABLE',
	CREDIT_BOOK = 'CREDIT_BOOK',
	CASH_BOOK = 'CASH_BOOK',
	BALANCE = 'BALANCE',
	INVOICE = 'INVOICE',
	INVOICE_CANCEL = 'INVOICE',
	INVOICE_APPROVAL = 'INVOICE_APPROVAL',
	CANCEL = 'CANCEL',
	CANCEL_APPROVAL = 'CANCEL_APPROVAL',
}

export enum OPT_TYPE {
	ADD = 1,
	REMOVE = 2,
}

//记录各种单价的上浮
export enum RATES {
	RATE = 1.02,
	OU_HAO = 1.04,
	YUN_HU = 1.04,
}


export enum calculateStatusEnum {
    'DRAFT'='草拟',
    'INIT'='已开单',
    'FINISH'='已完结'
}

export enum EquilibriumEnum {
    JUST = "+0.01",
    NEGATIVE = "-0.01"
}

export enum IconStatusEnum {
	'首页'='icon-shouye',
	// '物资管理'='icon-cangkuguanli',
	'资产盘点'='icon-xiaoshoudingdan',
	// '基础数据'='icon-peijiandangan',
	// '申请管理'='icon-yuyueguanli',
	'物资入库'='icon-mendianguanli',
	'物资领取'='icon-kucunpandian',
	'物资归还'='icon-caigoutuihuodan',
	'物资报废'='icon-chukudanju',
	'物资转移'='icon-weixiujiejian',
	'资产清单'='icon-peijiandangan',
	'数据字典'='icon-gongdanguanli',
	'物资档案'='icon-lishigongdan',
	'仓库管理'='icon-kucuntongji',
	'用户管理'='icon-weixiujishi',
	'组织机构'='icon-jigouguanli',
	'资产分类'='icon-xiaoshoudan',
	'审批设置'='icon-rukudanju',
	'申请列表'='icon-kehuguanli',
}

export enum IconColorEnum {
	'首页'='#47C9D3',
	// '物资管理'='#FFC335',
	'资产盘点'='#51DF92',
	// '基础数据'='#41ADF2',
	// '申请管理'='#F78A3C',
	'物资入库'='#7D6DFC',
	'物资领取'='#47C98A',
	'物资归还'='#f87272',
	'物资报废'='#F6563E',
	'物资转移'='#2cdd9c',
	'资产清单'='#FFC335',
	'数据字典'='#3381f8',
	'物资档案'='#ffac33',
	'仓库管理'='#3e67f4',
	'用户管理'='#fac858',
	'组织机构'='#52c41a',
	'资产分类'='#7EDC4B',
	'审批设置'='#58D4DE',
	'申请列表'='#ff9107',
	'物资清理'='#ff9107',
}
export enum IconUrlEnum {
	'首页'='',
	// '物资管理'='#FFC335',
	'资产盘点'='3-1',
	// '基础数据'='#41ADF2',
	// '申请管理'='#F78A3C',
	'物资入库'='2-1',
	'物资领取'='2-2',
	'物资归还'='2-3',
	'物资报废'='2-4',
	'物资转移'='2-5',
	'物资清理'='2-7',
	'资产清单'='2-6',
	'数据字典'='4-1',
	'物资档案'='4-2',
	'仓库管理'='4-3',
	'用户管理'='4-4',
	'组织机构'='4-5',
	'资产分类'='4-6',
	'审批设置'='4-7',
	'申请列表'='5-1',
}
export enum IconNameEnum {
	'/'='首页',
	'/inventory/assetsInventory'='资产盘点',
	'/manage/assetsEntry'='物资入库',
	'/manage/assetsGet'='物资领取',
	'/manage/assetsReturn'='物资归还',
	'/manage/assetsAbandon'='物资报废',
	'/manage/assetsMove'='物资转移',
	'/manage/assetsList'='资产清单',
	'/base/dict'='数据字典',
	'/base/assetsArchives'='物资档案',
	'/base/warehouseManage'='仓库管理',
	'/base/userControl'='用户管理',
	'/base/organization'='组织机构',
	'/base/assetsClass'='资产分类',
	'/base/assetsAsk'='审批设置',
	'/apply/applyList'='申请列表',
	'/manage/assetsClear'='物资转移',
}